import * as React from 'react';
import { AddToCart } from '@grandvisionhq/carts-v2';
import { useIntl } from '@grandvisionhq/state';
import '@swc/helpers';
import '@grandvisionhq/analytics';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/utils';
import { ProductRecommendationAction } from '../../../../../../ProductBlock/types.js';
import '@grandvisionhq/frk-routing';
import '../../../../../../ProductBlock/utils/get-variant-images.js';
import '@grandvisionhq/inventory';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/fun-products';
import '../../../../../../../types.js';
import '@grandvisionhq/api-client';
import { ProductBlockActionSuccessText } from '../ProductBlockActionSuccessText/ProductBlockActionSuccessText.js';

const ProductBlockAction = ({ productType , activeSku , action , onAddProduct , tabIndex ,  })=>{
    const { getLabel  } = useIntl();
    const [quantity, setQuantity] = React.useState(1);
    const [productAddedToCart, setProductAddedToCart] = React.useState(false);
    const itemDraft = {
        sku: activeSku,
        quantity,
        type: 'regular'
    };
    const addProduct = ()=>{
        setProductAddedToCart(true);
        onAddProduct && onAddProduct();
    };
    if (!action || action === ProductRecommendationAction.Redirect) return null;
    if (productAddedToCart) {
        return /*#__PURE__*/ React.createElement(ProductBlockActionSuccessText, null);
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-block-action"
    }, /*#__PURE__*/ React.createElement(AddToCart, {
        onSuccess: addProduct,
        variant: "ghost",
        caption: getLabel('cart.actions.addToCart'),
        lineItemDrafts: [
            itemDraft
        ],
        handleQuantityUpdate: setQuantity,
        quantity: quantity,
        isQuantitySelectorEnabled: action === 'addQuantity',
        productType: productType,
        tabIndex: tabIndex
    }));
};

export { ProductBlockAction };
//# sourceMappingURL=ProductBlockAction.js.map
